import { useApolloClient, useFragment } from "@apollo/client"

import { RoomTypename } from "shared/types/Project"

import {
  RoomCompleteFragment,
  RoomCompleteFragmentDoc
} from "entities/rooms/graphql/fragments.generated"

export function useRoomFragment(id: string) {
  const { cache } = useApolloClient()

  const { complete, data: room } = useFragment<RoomCompleteFragment>({
    fragment: RoomCompleteFragmentDoc,
    fragmentName: "RoomComplete",
    from: cache.identify({ id, __typename: RoomTypename })
      ? { id, __typename: RoomTypename }
      : null
  })

  return complete ? room : undefined
}
